<template>
    <div class="page-box">
        <el-form :model="form" ref="form" :rules="rules" label-width="0" :inline="false" size="normal">
            <el-form-item label="">
                <el-radio-group v-model="form.show">
                    <el-radio :label="1">禁止显示</el-radio>
                    <el-radio :label="0">允许显示</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>

    </div>
</template>
<script>
import { ctrlTeamIsShowOpt } from "@/pages/score/api/mymatchs/matchs.js";
export default {
    name: "opt-show",
    data() {
        return {
            form: {
                show: 0
            },
            rules: {}
        };
    },
    created(){
        const { showflag } = this.$attrs.params;
        if(String(showflag).length>0){
            this.form.show = Number(showflag);
        }
    },
    methods: {
        async confirm(callback, close) {
            if(this.$attrs.params.showflag == String(this.form.show)) return close()
            const res = await ctrlTeamIsShowOpt([this.$attrs.params.id]);
            if(res && res.code == 200){
                this.$message.success('操作成功')
            }else{
                res && res.message && this.$message.error(res.message)
            }
            close();
            callback();
        }
    }
}
</script>
<style lang="scss" scoped>
.page-box {
    width: calc(100% - 20px);
    height: 80px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>